import React from 'react'
import MaskedInput from 'react-text-mask'
function InputCPFCNPJ({ value, onChange }) {

    const cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    const cnpjMask = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];

    const [mask, setMask] = React.useState(cnpjMask);
    const [backValue, setBackValue] = React.useState(0)


    const handleInputChange = (e) => {
        const inputValue = e.target.value.replace(/\D/g, ''); // Remove caracteres não numéricos
        if (inputValue.length <= 11 && backValue < 11 ) {
            setMask(cpfMask);
        } else {
            setMask(cnpjMask);
        }
        if(inputValue.length > 11){
            setMask(cnpjMask)
        }
        setBackValue(inputValue.length)
        onChange(inputValue);
    };

    return (
        <MaskedInput inputMode='numeric' mask={mask} placeholder='CPF/CNPJ' className="form-control" value={value} onChange={value => {
            handleInputChange(value)
        }}></MaskedInput>)
}

export default InputCPFCNPJ